export default {
  pl: {
    navbar: {
      shop_: 'Sklep',
      about_: 'O nas',
      lookBook_: 'Lookbook',
      cart_: 'Koszyk',
      contact_: 'Kontakt'
    },
    cart: {
      totalProducts_: 'Łącznie',
      changed_: 'Zaktualizowano koszyk.',
      final_: 'Podsumowanie',
      totalMoney_: 'Łącznie',
      shipping_: 'Przesyłka',
      cartEmpty_: 'Koszyk jest pusty.',
      discountCode_: 'Posiadam kupon rabatowy.',
      discountCodeInactive_: 'Kod jest nieważny.',
      calc_: 'Przelicz'
    },
    products: {
      noProducts_: 'Niestety nie posiadamy aktualnie żadnych produktów'
    },
    form: {
      name_: 'Imię',
      nameError_: 'Podaj poprawne imię',
      surname_: 'Nazwisko',
      surnameError_: 'Podaj poprawne nazwisko',
      address_: 'Adres',
      addressError_: 'Podaj poprawny adres',
      city_: 'Miasto',
      cityError_: 'Podaj poprawne miasto',
      code_: 'Kod pocztowy',
      codeError_: 'Podaj poprawny kod pocztowy',
      email_: 'Email',
      emailError_: 'podaj poprawny adres email',
      phone_: 'Numer telefonu',
      phoneError_: 'Podaj poprawny numer telefonu',
      rules_: 'Akceptuje regulamin',
      rulesError_: 'Zaakceptuj regulamin',
      noProductsError_: 'Nie ma wystarczającej liczby produktów.',
      submit_: 'Złóż zamówienie',
      summariseButton_: 'Zamawiam i płacę',
      errors: {
        error_: 'Błąd',
        noItems_: 'Nie ma wystarczającej liczby produktów.',
        incorrectData_: 'Podaj poprawne dane',
        badCode_: 'Niepoprawny kod',
        inActiveCode_: 'Kod zniżkowy jest nieaktywny'
      }
    },
    productPage: {
      addToCart_: 'Dodaj do koszyka',
      incorrectEmail_: 'Podaj poprawny email',
      notify_: 'Wyprzedane, Powiadom mnie',
      added_: 'Dodano',
      notifyMsg1_: 'Pomyślnie zapisaliśmy adres',
      notifyMsg2_: 'Poinformujemy cię gdy produkt będzie dostępny',
      error_: 'Błąd',
      notAdded_: 'Nie udało się dodać. Spróbuj jeszcze raz!'
    },
    summarise: {
      pay_: 'Zamawiam i płacę',
      payLater_: 'Płacę przy odbiorze',
      noProducts_: 'Niewystarczająca ilość produktów',
      error_: 'Problemy techniczne. Przepraszamy',
      errorTitle_: 'Błąd',
      addShipping_: 'Wysyłka pod wskazany adres',
      notAddShipping_: 'Odbiór osobisty'
    },
    orderSuccess: {
      msg1_: 'Dziękujemy za złozenie zamówienia nr',
      msg2_: 'Niezwłocznie przystępujemy do jego realizacji. Na adres mailowy',
      msg3_: 'wysłaliśmy potwierdznie zamówienia'
    },
    footer: {
      rules_: 'Regulamin',
      returns_: 'Zwroty',
      privacy_: 'Polityka prywatności/Cookies',
      contact_: 'Kontakt'
    },
    spotfinder: {
      header_: 'Sprawdź naszą aplikację Spotfinder!',
      desc_: `Aplikacja powstała po to, aby będąc w nowym miejscu nie tracić czasu na przeciętne spoty.
      Deska, szama, impreza czy po prostu chwila chillout'u?
      Po prostu uruchom aplikację i zacznij eksplorować mapę. Gdy sam trafisz na miejsce,
      które twoim zdaniem jest godne uwagi - dodaj je, a użytkownicy swoimi reakcjami zweryfikują czy masz rację.`,
      subheader_: 'Stwórzmy razem coś dużego!'
    }
  },
  en: {
    navbar: {
      shop_: 'Shop',
      about_: 'About',
      lookBook_: 'Lookbook',
      cart_: 'Cart',
      contact_: 'Contact'
    },
    cart: {
      totalProducts_: 'Total',
      changed_: 'Changed cart.',
      final_: 'Summary',
      totalMoney_: 'Total',
      shipping_: 'Shipping',
      cartEmpty_: 'Cart is empty.',
      discountCode_: 'I have discount code.',
      discountCodeInactive_: 'Code invalid.',
      calc_: 'Calculate'
    },
    products: {
      noProducts_: 'Unfortunately we do not have products now.'
    },
    form: {
      name_: 'Name',
      nameError_: 'Sign correct name',
      surname_: 'Surname',
      surnameError_: 'Sign correct Surname',
      address_: 'Address',
      addressError_: 'Sign correct address',
      city_: 'City',
      cityError_: 'Sign correct city',
      code_: 'Post code',
      codeError_: 'Sign correct post code',
      email_: 'Email',
      emailError_: 'Sign correct email address',
      phone_: 'Phone number',
      phoneError_: 'Sign correct phone number',
      rules_: 'Accept rules',
      rulesError_: 'Accept Rules',
      noProductsError_: 'There is no enought number of products.',
      submit_: 'Create order',
      summariseButton_: 'Order and pay',
      errors: {
        error_: 'Error',
        noItems_: 'There is no enought products',
        incorrectData_: 'Assign correct data',
        badCode_: 'Wrong code',
        inActiveCode_: 'Discount code inactive'
      }
    },
    productPage: {
      addToCart_: 'Add to cart',
      incorrectEmail_: 'Assign correct email',
      notify_: 'Sold out, Notify me',
      added_: 'Added',
      notifyMsg1_: 'Successfuly saved email',
      notifyMsg2_: 'We will notify you when it will be available.',
      error_: 'Error',
      notAdded_: 'There was an error. Try again.'
    },
    summarise: {
      pay_: 'Order and pay',
      payLater_: 'Cash on delivery',
      noProducts_: 'There is not enough products',
      error_: 'Technical issues. We are sorry.',
      errorTitle_: 'Error',
      addShipping_: 'Shipping to the provided address',
      notAddShipping_: 'Personal pickup'
    },
    orderSuccess: {
      msg1_: 'Thank you for your visit',
      msg2_: 'We are start completing your order immediately. On email address',
      msg3_: 'we sent confirmation of your order'
    },
    footer: {
      rules_: 'Rules',
      returns_: 'Returns',
      privacy_: 'Privacy policy/Cookies',
      contact_: 'Contact'
    },
    spotfinder: {
      header_: 'Check out our app SpotFinder',
      desc_: `App was created to help you find best spots when you are in new area.
      Skateboard, food, party or maybe chillout?
      Just open the app and start to explore the map. When you are in place you think is valuable - 
      add it and users will decide if you are right by reactions..`,
      subheader_: 'Let\'s make something great together!'
    }
  }
}
